import { render, staticRenderFns } from "./ModalViewContract.vue?vue&type=template&id=04e40c06&lang=pug"
import script from "./ModalViewContract.vue?vue&type=script&lang=js"
export * from "./ModalViewContract.vue?vue&type=script&lang=js"
import style0 from "./ModalViewContract.vue?vue&type=style&index=0&id=04e40c06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports